import {
  FEATURED_INDUSTRIES,
  FALLBACK_REMAINING_INDUSTRIES,
  FALLBACK_LOCATIONS,
} from "../container/Onboarding/constants";

/**
 * Shared Industry / Location catalogs used when GET /extent/industry/
 * or GET /extent/locations/ is empty, unauthenticated, or unavailable.
 * Same lists onboarding already falls back to — not a new mockset.
 */
export const FALLBACK_INDUSTRY_CHOICES = [
  ...FEATURED_INDUSTRIES,
  ...FALLBACK_REMAINING_INDUSTRIES,
];

export const FALLBACK_LOCATION_CHOICES = FALLBACK_LOCATIONS;

/**
 * Use a successful non-empty extent payload; otherwise keep the existing catalog.
 */
export function pickExtentChoices(response, fallback) {
  const data = response?.data;
  if (Array.isArray(data) && data.length > 0) return data;
  return fallback;
}
